import React from 'react';
import { modules, promises } from '../data/modules';
import { OFFER_ANCHOR, PRODUCT_ALT, PRODUCT_IMG } from './constants';
export function SystemSection() {
  return <section className="bg-white px-4 py-5" data-id="element-137" data-mp="3gg5aviwskaka">
      <div className="mx-auto max-w-4xl" data-id="element-138" data-mp="3bhu0n72l3y1j">
        <div className="mb-3 text-center" data-id="element-139" data-mp="3bkzlub83efrz">
          <p className="mb-1 font-display text-[11px] font-semibold uppercase tracking-widest text-brand-orange sm:text-sm" data-id="element-140" data-mp="36klfcxm53dw2">
            Il sistema completo che stavi cercando
          </p>
          <h2 className="mb-1 font-display text-lg font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-141" data-mp="2wtgyttgtfkz4">
            Un unico sistema Smart Home 6-in-1
          </h2>
          <div className="mb-2 inline-block rounded-lg bg-brand-graphite px-3 py-1.5 text-white shadow-md" data-id="element-142" data-mp="2sq16387va4rp">
            <p className="font-display text-xs font-bold uppercase tracking-wide text-white sm:text-base" data-id="element-143" data-mp="2iu7w9wlj8pdm">
              SMART HOME PRO™
            </p>
            <p className="text-[11px] font-semibold text-white/85 sm:text-sm" data-id="element-144" data-mp="2dwfri1zsh8s0">
              Il Sistema Completo per Imparare, Installare e Gestire la Domotica
            </p>
          </div>
          <p className="mx-auto max-w-3xl text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-145" data-mp="18qzovm7gcwh4">
            Non è un’altra raccolta di informazioni casuali sulla domotica. È un percorso progressivo
            progettato per accompagnarti dalle basi fino alla realizzazione ragionata di sistemi
            Smart Home completi. Con SMART HOME PRO™ puoi:
          </p>
          <ul className="mt-1 flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 text-[11px] font-semibold text-brand-ink sm:text-sm" data-id="element-146" data-mp="1rp2ars4pedap">
            {promises.map(promise => <li key={promise} data-id="element-147" data-mp="1hq3b2z1x1rzu">✔ {promise}</li>)}
          </ul>
        </div>

        <div className="grid gap-2 sm:grid-cols-2" data-id="element-148" data-mp="1cmlojqe5ogl">
          {modules.map(module => <a key={module.num} href={OFFER_ANCHOR} className="group flex gap-3 rounded-xl border border-brand-line bg-brand-cream p-3 shadow-sm transition-colors duration-150 ease-out hover:border-brand-orange" data-id="element-149" data-mp="6bg14hp8npje">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-graphite font-display text-sm font-extrabold text-white transition-colors duration-150 ease-out group-hover:bg-brand-orange" data-id="element-150" data-mp="23ztjk4zl44im">
                {module.num}
              </span>
              <div data-id="element-151" data-mp="1pax4vp30vt91">
                <h3 className="font-display text-[13px] font-bold leading-tight text-brand-ink sm:text-base" data-id="element-152" data-mp="1pbgorbc8grpp">
                  ✅ {module.title}
                </h3>
                <p className="mt-0.5 text-xs font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-153" data-mp="1gaih8j2l622d">
                  {module.description}
                </p>
              </div>
            </a>)}
        </div>

        <div className="mt-3 text-center" data-id="element-154" data-mp="3amyjz9w6ay2h">
          <a href={OFFER_ANCHOR} className="inline-block" aria-label="Vai alla sezione di acquisto" data-id="element-155" data-mp="35odsbyuzlmpn">
            <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[220px] object-contain drop-shadow-xl transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-156" data-mp="3d86aojb60zgl" />
          </a>
        </div>
      </div>
    </section>;
}